module.exports = __webpack_public_path__ + "img/hollywood.99b9ae4d.jpg";